// extracted by mini-css-extract-plugin
export default {"cta":"OF-z","disabled":"PF-z"};